import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ConfirmModalComponent, IConfirmSettings } from 'src/app/shared/components/confirm-modal/confirm-modal.component';

@Injectable({
  providedIn: 'root'
})
export class Intercept404Service implements HttpInterceptor {
  private router = inject(Router);
  private dialog = inject(MatDialog);

  intercept(req: HttpRequest<never>, next: HttpHandler): Observable<HttpEvent<string>> {
    return next.handle(req).pipe(
      catchError((err) => {
        switch (err.status) {
          case 403:
            this.displayForbiddenConfirmation();
            return EMPTY;
          case 404:
            this.router.navigateByUrl('/error404').then();
            return EMPTY;
          default:
            return throwError(() => err);
        }
      })
    );
  }

  displayForbiddenConfirmation() {
    const data: IConfirmSettings = {
      title: 'You have no permission to run this action',
      info: 'You do not have the required permissions to run this action. If you believe this is a mistake, please contact your administrator.',
      showDismiss: false,
      confirmButtonLabel: 'OK'
    };
    this.dialog.open<ConfirmModalComponent, IConfirmSettings, { confirmed: boolean }>(ConfirmModalComponent, {
      data,
      autoFocus: false
    });
  }
}
